import {
  AccordionItem,
  Text,
  List,
  Stack,
  Heading,
  Strong,
} from 'braid-design-system';
export const SectionE = () => (
  <AccordionItem id="section-e" label="Section E: Questionnaire Panel">
    <Stack space="gutter">
      <Heading level="4">Functional</Heading>
      <List type="number" start={83}>
        <Text>
          Section E applies if you have chosen to use the Questionnaire Panel
          functionality through the SEEK API.
        </Text>
        <Text>
          <Strong>Questionnaire Panel</Strong> means our questionnaire panel
          that you can embed into your posting flow to select and create
          questions to assign to a job ad during advertisement creation.
        </Text>
        <Stack space="medium">
          <Text>You acknowledge and agree that:</Text>
          <List type="alpha">
            <Text>
              If you choose to use the Questionnaire Panel, it must be made
              available to all Advertisers. Removal of this panel for any
              Advertiser must be discussed and agreed with us beforehand;
            </Text>
            <Text>
              if you have chosen to embed the Questionnaire Panel, you agree to
              use these questions only for their intended purpose;
            </Text>
            <Text>
              within the Questionnaire Panel, all our questions returned as a
              result of the query to retrieve questions from us must be visible
              and selectable for the Advertiser posting the job ad; and
            </Text>
            <Text>
              any questions created as part of the advertisement creation that
              are not selected from our existing library of questions must
              adhere to applicable Privacy Laws and these Terms.
            </Text>
          </List>
        </Stack>
      </List>
      <Heading level="4">Messaging / Branding</Heading>
      <List type="number" start={86}>
        <Text>
          You must not change or modify any design elements related to the
          Questionnaire Panel, unless we have provided consent for you to do so.
        </Text>
        <Text>
          If you believe an element of the design is sub-optimal for your users,
          you may request a design change by contacting us, which we will
          consider in our sole discretion.
        </Text>
      </List>
    </Stack>
  </AccordionItem>
);
